import { MOBILE_FULL_WIDTH_DATA_ATTRIBUTE as e } from "../extensions/image-extension/constants/index.mjs";
//#region src/constants/default-styles.ts
var t = "#000000", n = "15px", r = "#ffffff", i = "1rem", a = {
	marginTop: 0,
	marginBottom: 0
}, o = {
	2: {
		marginTop: "0.83em",
		marginBottom: "0.83em",
		fontSize: "1.5em",
		lineHeight: "normal",
		fontFamily: "inherit",
		fontWeight: "bold"
	},
	3: {
		marginTop: "1em",
		marginBottom: "1em",
		fontSize: "1.17em",
		lineHeight: "normal",
		fontFamily: "inherit",
		fontWeight: "bold"
	},
	4: {
		marginTop: "1.33em",
		marginBottom: "1.33em",
		lineHeight: "normal",
		fontFamily: "inherit",
		fontWeight: "bold",
		fontSize: "1em"
	}
}, s = {
	marginTop: i,
	marginBottom: i,
	paddingLeft: "40px"
}, c = {
	display: "table",
	clear: "both",
	textAlign: "center",
	minWidth: "50px",
	maxWidth: "100%",
	margin: ".9em auto"
}, l = `@media (max-width: 600px) { figure[${e}="true"] { width: 100% !important; } }`, u = `@media (max-width: 600px) { img[${e}="true"] { width: 100% !important; max-width: 100% !important; } }`, d = (e) => ({
	display: "table",
	float: "right",
	clear: "both",
	textAlign: "center",
	minWidth: "50px",
	maxWidth: "100%",
	margin: e ? `${i} 0 .9em 1.5em` : "0 0 .9em 1.5em"
}), f = {
	display: "block",
	margin: "0 auto",
	minWidth: "100%",
	maxWidth: "100%"
}, p = {
	display: "table-caption",
	captionSide: "bottom",
	wordBreak: "break-word",
	textAlign: "center",
	color: "var(--color-text-primary)",
	backgroundColor: "var(--color-bg-primary)",
	padding: ".6em",
	fontSize: ".75em",
	outlineOffset: "-1px"
};
//#endregion
export { f as BLOCK_IMAGE_STYLES, r as DEFAULT_BG_COLOR, t as DEFAULT_COLOR, n as DEFAULT_FONT_SIZE, p as FIGCAPTION_STYLES, c as FIGURE_CENTERED_STYLES, l as FIGURE_MOBILE_FULL_WIDTH_STYLES, o as HEADING_STYLES, u as IMAGE_MOBILE_FULL_WIDTH_STYLES, s as LIST_STYLES, a as PARAGRAPH_STYLES, d as getFigureRightStyles };
